module.exports = __webpack_public_path__ + "static/img/ecg_green_top_new.80b28052.png";